import { FC } from 'react';

import NotFoundScreen from '@modules/core/views/NotFoundScreen';

import { usePermissions } from '../../hooks';
import { RequirePermissionProps } from './RequirePermission.types';

const RequirePermission: FC<RequirePermissionProps> = ({ children, to, redirect }) => {
  const { hasPermission } = usePermissions();

  if (redirect) {
    return hasPermission(to) ? <>{children}</> : <NotFoundScreen />;
  }

  return hasPermission(to) ? <>{children}</> : null;
};

export default RequirePermission;
